webpackJsonp([180189194464636,97701843481733],{

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Camera;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Camera() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "44", height: "38", viewBox: "0 0 44 38" },
	    _react2.default.createElement("path", { d: "M42,7.15a2.3,2.3,0,0,0-1.2-.62q-2.46-.25-7.37-0.64-1-3.41-1.18-3.81A2.74,2.74,0,0,0,31.38.87,2.32,2.32,0,0,0,30.1.3Q26,0,22,0t-7.91.3a2.32,2.32,0,0,0-1.28.57,2.73,2.73,0,0,0-.88,1.21q-0.15.4-1.18,3.81l-7.32.64a2.32,2.32,0,0,0-1.25.62,2,2,0,0,0-.66,1.16A75.38,75.38,0,0,0,0,21.89,71.49,71.49,0,0,0,1.52,35.23a1.87,1.87,0,0,0,.66,1.14A2.38,2.38,0,0,0,3.44,37,166.67,166.67,0,0,0,22,38a171.53,171.53,0,0,0,18.81-1,2.37,2.37,0,0,0,1.2-.59,2.14,2.14,0,0,0,.71-1.14,71.59,71.59,0,0,0,0-26.92A2.27,2.27,0,0,0,42,7.15ZM9,21a12.51,12.51,0,0,1,3.84-9.16A12.5,12.5,0,0,1,22,8a12.51,12.51,0,0,1,9.16,3.84A12.51,12.51,0,0,1,35,21a12.5,12.5,0,0,1-3.84,9.16A12.51,12.51,0,0,1,22,34a12.5,12.5,0,0,1-9.16-3.84A12.5,12.5,0,0,1,9,21Zm13-8a8,8,0,0,1,8,8,8,8,0,0,1-8,8,8,8,0,0,1-8-8A8,8,0,0,1,22,13Z" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Hammer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Hammer() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "38", height: "38", viewBox: "0 0 38 38" },
	    _react2.default.createElement("path", { d: "M37,16.68l-2-1.91a2.7,2.7,0,0,1-3.88,0,2.67,2.67,0,0,1,0-3.87L27.29,7C22.06,1.85,15.57-.68,10.22.16a1.2,1.2,0,0,0-.61.19A1.53,1.53,0,0,0,9,1.52V1.8a1.53,1.53,0,0,0,.94,1.38A20.24,20.24,0,0,1,16.6,8c2.71,2.79,3.19,6.57,1,8.83L7.63,26.62,4.94,23.79a3,3,0,0,0-4.05,0,2.47,2.47,0,0,0,0,3.77l9.59,9.65a2.81,2.81,0,0,0,1.93.78,2.56,2.56,0,0,0,2-.93,2.74,2.74,0,0,0-.28-3.68l-2.61-3L24.76,17.63c1.11-1.1-.23,1.9.88,3a2.63,2.63,0,0,1,0,3.87l2,1.93a2.7,2.7,0,0,0,3.88,0l5.83-5.78a2.87,2.87,0,0,0-.26-4Z" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Sync;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Sync() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "38", height: "38", viewBox: "0 0 38 38" },
	    _react2.default.createElement("path", { d: "M36.27,1.06a1.29,1.29,0,0,0-1.36.34L31.35,5A18.27,18.27,0,0,0,18.62,0,18.36,18.36,0,0,0,8.2,3.16a17.83,17.83,0,0,0-6.56,8.16q-1.32,3,.21,3.52a1.55,1.55,0,0,0,.45.11,1.31,1.31,0,0,0,.51-0.06l0.47-.15a2.75,2.75,0,0,0,.55-0.3l0.57-.36,0.72-.47,0.76-.51a17,17,0,0,1,4.44-2.42A13.39,13.39,0,0,1,14.65,10a28.3,28.3,0,0,1,4.09.45,12.7,12.7,0,0,1,4.88,2.21L20.27,15.9a1.35,1.35,0,0,0-.34,1.36,1.31,1.31,0,0,0,1,.93A47.76,47.76,0,0,0,30,19q1,0,2.06,0l1.78-.08,1.34-.08,0.93-.08,0.34,0a1.23,1.23,0,0,0,1.19-1.19q0.13-1,.25-2.61t0-5.62a41.25,41.25,0,0,0-.72-7.17,1.25,1.25,0,0,0-1-1h0Zm-6.51,33.8a18.1,18.1,0,0,0,6.6-8.25q1.31-3-.25-3.52L35.76,23a1.56,1.56,0,0,0-.36,0l-0.34.06a2.54,2.54,0,0,0-.4.17l-0.4.21-0.47.28-0.51.32-0.57.38-0.59.38a17.26,17.26,0,0,1-4.44,2.48,13.44,13.44,0,0,1-4.35.66,27.36,27.36,0,0,1-4.07-.45,13.09,13.09,0,0,1-4.88-2.21l3.35-3.22a1.35,1.35,0,0,0,.34-1.36A1.25,1.25,0,0,0,17,19.81,47.83,47.83,0,0,0,7.93,19q-1,0-2,0l-1.78.08-1.36.08-0.93.08-0.34,0A1.22,1.22,0,0,0,.33,20.53q-0.13,1-.25,2.63t0,5.62a41,41,0,0,0,.72,7.15,1.32,1.32,0,0,0,.93,1,1.38,1.38,0,0,0,.42.08A1.3,1.3,0,0,0,3,36.6L6.61,33a18.32,18.32,0,0,0,12.77,5A18.38,18.38,0,0,0,29.76,34.86Z" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = tv;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function tv() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "40", height: "38", viewBox: "0 0 40 38" },
	    _react2.default.createElement("path", { d: "M37.37,1.31Q37,1.23,36.46,1.17L35.1,1Q34.29,0.86,33.31.76l-2.12-.2-2.46-.2L26,0.16q-1.4-.08-3-0.12T20,0q-1.5,0-3.08,0t-3,.12l-2.71.18-2.46.2-2.12.2q-1,.1-1.81.23L3.5,1.17Q3,1.23,2.58,1.31l-0.37,0a2.58,2.58,0,0,0-1.58.9A2.52,2.52,0,0,0,0,3.93V26.21a2.45,2.45,0,0,0,.62,1.66,2.82,2.82,0,0,0,1.58.92A118.66,118.66,0,0,0,15,30v3.11L6.29,35.42a1.27,1.27,0,0,0-1,1.47,1.33,1.33,0,0,0,.46.78,1.29,1.29,0,0,0,.87.33H33.33a1.29,1.29,0,0,0,.87-0.33,1.34,1.34,0,0,0,.46-0.78,1.27,1.27,0,0,0-1-1.47L25,33.13V30a118.67,118.67,0,0,0,12.79-1.23,2.82,2.82,0,0,0,1.58-.92A2.45,2.45,0,0,0,40,26.21V3.93a2.48,2.48,0,0,0-.65-1.68,2.68,2.68,0,0,0-1.6-.9ZM5,24V5.92A124.27,124.27,0,0,1,20,5a124.28,124.28,0,0,1,15,.94V24a125.33,125.33,0,0,1-15,1A125.32,125.32,0,0,1,5,24H5Z" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = watch;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function watch() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "26.03", height: "38", viewBox: "0 0 26.03 38" },
	    _react2.default.createElement("path", { d: "M25.09,12H24.94V10.25a4.18,4.18,0,0,0-2.57-3.38C19.7,5.15,19.86,2.11,19.8,1.52,19.6,0.15,17.14,0,14.47,0H10.09C7.37,0,4.91.2,4.76,1.52,4.65,2.11,4.81,5.4,1.93,7H2a3.72,3.72,0,0,0-2,3.2V27.8A3.68,3.68,0,0,0,2,31H1.93c2.87,1.57,2.72,4.91,2.82,5.45C4.91,37.85,7.37,38,10.09,38h4.39c2.67,0,5.12-.2,5.33-1.52,0-.59-0.1-3.63,2.56-5.35a4.09,4.09,0,0,0,2.57-3.38V26.08a2.26,2.26,0,0,0,1-.45V20.47a1.78,1.78,0,0,0-1-.39V16H25.1a1,1,0,0,0,.9-1.22V13a0.91,0.91,0,0,0-.82-1H25.09ZM22,27.52A1.45,1.45,0,0,1,20.55,29H4.46A1.46,1.46,0,0,1,3,27.51v-17A1.46,1.46,0,0,1,4.44,9H20.54A1.46,1.46,0,0,1,22,10.49v17Z" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Wifi;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Wifi() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "44", height: "38", viewBox: "0 0 44 38" },
	    _react2.default.createElement("path", { d: "M9.25,32.15a2.92,2.92,0,0,0,0-3.88A17.43,17.43,0,0,1,4.93,16.5,17.43,17.43,0,0,1,9.25,4.72a3,3,0,0,0,0-3.9A2.19,2.19,0,0,0,5.8.85,23.35,23.35,0,0,0,0,16.5,23.35,23.35,0,0,0,5.8,32.15,2.18,2.18,0,0,0,9.25,32.15Zm7-6.13a2.8,2.8,0,0,0,0-3.82A9.1,9.1,0,0,1,14,16.34a8.63,8.63,0,0,1,2.25-5.72,2.8,2.8,0,0,0,0-3.82,2.3,2.3,0,0,0-3.53,0,14.46,14.46,0,0,0,0,19.33,2.35,2.35,0,0,0,1.75.83A1.86,1.86,0,0,0,16.24,26Zm2.91-11.88a4,4,0,1,0,5.7,0A4.11,4.11,0,0,0,19.15,14.15Zm6.59,13a3.77,3.77,0,1,0-7.5,0L17,38H27Z" }),
	    _react2.default.createElement("path", { d: "M34.75,32.15a2.92,2.92,0,0,1,0-3.88A17.43,17.43,0,0,0,39.07,16.5,17.43,17.43,0,0,0,34.75,4.72a3,3,0,0,1,0-3.9,2.19,2.19,0,0,1,3.45,0A23.35,23.35,0,0,1,44,16.5a23.35,23.35,0,0,1-5.8,15.65A2.18,2.18,0,0,1,34.75,32.15Zm-7-6.13a2.8,2.8,0,0,1,0-3.82A9.1,9.1,0,0,0,30,16.34a8.63,8.63,0,0,0-2.25-5.72,2.8,2.8,0,0,1,0-3.82,2.3,2.3,0,0,1,3.53,0,14.46,14.46,0,0,1,0,19.33,2.35,2.35,0,0,1-1.75.83A1.86,1.86,0,0,1,27.76,26Z" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 1222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _apps2x = __webpack_require__(2538);
	
	var _apps2x2 = _interopRequireDefault(_apps2x);
	
	var _googlePlay2x = __webpack_require__(862);
	
	var _googlePlay2x2 = _interopRequireDefault(_googlePlay2x);
	
	var _appStore2x = __webpack_require__(861);
	
	var _appStore2x2 = _interopRequireDefault(_appStore2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  apps: {
	    alt: 'Marvel mobile apps for prototyping',
	    maxWidth: 700,
	    src: _apps2x2.default,
	    hasShadow: false
	  },
	  googlePlay: {
	    alt: 'Google Play',
	    maxWidth: 180,
	    src: _googlePlay2x2.default
	  },
	  appStore: {
	    alt: 'Apple App Store',
	    maxWidth: 180,
	    src: _appStore2x2.default
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 861:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 2538:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/apps@2x-4f5726afb22d2a76eadc973f937118a3.jpg";

/***/ }),

/***/ 862:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Features;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Wifi = __webpack_require__(535);
	
	var _Wifi2 = _interopRequireDefault(_Wifi);
	
	var _Camera = __webpack_require__(525);
	
	var _Camera2 = _interopRequireDefault(_Camera);
	
	var _Sync = __webpack_require__(531);
	
	var _Sync2 = _interopRequireDefault(_Sync);
	
	var _Watch = __webpack_require__(534);
	
	var _Watch2 = _interopRequireDefault(_Watch);
	
	var _Hammer = __webpack_require__(530);
	
	var _Hammer2 = _interopRequireDefault(_Hammer);
	
	var _TV = __webpack_require__(532);
	
	var _TV2 = _interopRequireDefault(_TV);
	
	var _generalModule = __webpack_require__(485);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Features() {
	  var features = [{
	    id: 0,
	    name: 'Take photos of sketches',
	    description: 'Go from a napkin sketch to a fully functional prototype in minutes',
	    icon: _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.fillMarvel },
	      _react2.default.createElement(_Camera2.default, null)
	    )
	  }, {
	    id: 1,
	    name: 'Build prototypes',
	    description: 'Create beautifully presented desktop and mobile prototypes',
	    icon: _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.fillPurple },
	      _react2.default.createElement(_Hammer2.default, null)
	    )
	  }, {
	    id: 2,
	    name: 'Offline Prototypes',
	    description: 'Pre-download all your prototypes and view them with no internet connection',
	    icon: _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.fillTeal },
	      _react2.default.createElement(_Wifi2.default, null)
	    )
	  }, {
	    id: 3,
	    name: 'Sync from Sketch',
	    description: 'Seamlessly import prototypes and sync artboards from Sketch into Marvel',
	    icon: _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.fillOrange },
	      _react2.default.createElement(_Sync2.default, null)
	    )
	  }, {
	    id: 4,
	    name: 'Apple TV',
	    description: 'Marvel lets you play and preview all your prototypes on the Apple TV',
	    icon: _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.fillYellow },
	      _react2.default.createElement(_TV2.default, null)
	    )
	  }, {
	    id: 5,
	    name: 'Apple Watch',
	    description: 'View your prototypes directly on the Apple Watch',
	    icon: _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.fillGreen },
	      _react2.default.createElement(_Watch2.default, null)
	    )
	  }];
	
	  var featuresItems = features.map(function (feature) {
	    return _react2.default.createElement(
	      _grid.GridItem,
	      { columnSpan: 3, columnSpanM: 1, key: feature.id },
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', type: 'padding', position: 'topBottom' },
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 320 },
	            _react2.default.createElement(
	              'div',
	              null,
	              feature.icon
	            ),
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 'm', type: 'padding', position: 'top' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h3', weight: 'semibold', size: 'xl' },
	                feature.name
	              )
	            ),
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _paragraph2.default,
	                null,
	                feature.description
	              )
	            )
	          )
	        )
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center' },
	      _react2.default.createElement(
	        _maxWidth2.default,
	        { value: 920 },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'xl', type: 'padding', position: 'topBottom' },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center' },
	            _react2.default.createElement(
	              _grid2.default,
	              { columns: 3, size: 'l' },
	              featuresItems
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Pop;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _grid = __webpack_require__(5);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _assets = __webpack_require__(1222);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _Features = __webpack_require__(638);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _generalModule = __webpack_require__(485);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Pop() {
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: 'Apps | Marvel',
	      meta: [{
	        name: 'description',
	        content: 'Design and Prototype on the iPhone, iPad, Apple Watch, Apple TV & Android in the palm of your hand'
	      }, { name: 'keywords', content: '' }],
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'overflow-hidden' },
	      _react2.default.createElement(
	        'div',
	        { className: _generalModule2.default.wrap },
	        _react2.default.createElement(_Image2.default, _assets2.default.apps),
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 720 },
	          _react2.default.createElement(
	            'h1',
	            { className: _generalModule2.default.heading },
	            'Turn anything into interactive prototypes'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', type: 'padding', position: 'bottom' },
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 720 },
	            _react2.default.createElement(
	              'p',
	              { className: _generalModule2.default.subheading },
	              'Our apps let you create, play and share on the go.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.InlineGrid,
	          { startAfterS: true, size: 'm', sizeS: 'm' },
	          _react2.default.createElement(
	            _link2.default,
	            {
	              url: 'https://itunes.apple.com/us/app/marvel-app/id765801658?mt=8',
	              target: '_blank'
	            },
	            _react2.default.createElement(_Image2.default, _assets2.default.appStore)
	          ),
	          _react2.default.createElement(
	            _link2.default,
	            {
	              url: 'https://play.google.com/store/apps/details?id=com.marvelapp',
	              target: '_blank'
	            },
	            _react2.default.createElement(_Image2.default, _assets2.default.googlePlay)
	          )
	        )
	      ),
	      _react2.default.createElement(_Features2.default, null),
	      _react2.default.createElement(_Whitespace2.default, { size: 's', sizeS: 'l', sizeM: 'xl' })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrap":"src-pages-apps-style----general-module---wrap---aQUo6 pageWrap c-black textAlign-center pageWrap-l","heading":"src-pages-apps-style----general-module---heading---1TgIe fontWeight-5 marginBottom-m fontSize-xxxl lineHeight-title breakPointS-fontSize-xxxxl","subheading":"src-pages-apps-style----general-module---subheading---9ZLB8 fontSize-l lineHeight-copy c-slate breakPointS-fontSize-xl breakPointM-fontSize-xxl breakPointM-lineHeight-xxl fontWeight-4","fillPurple":"src-pages-apps-style----general-module---fillPurple---wuFLw fill-purple","fillMarvel":"src-pages-apps-style----general-module---fillMarvel---2xEvW fill-marvel","fillOrange":"src-pages-apps-style----general-module---fillOrange---3lBJA fill-orange","fillGreen":"src-pages-apps-style----general-module---fillGreen---3vvPS fill-green","fillTeal":"src-pages-apps-style----general-module---fillTeal---FAiKY fill-teal","fillYellow":"src-pages-apps-style----general-module---fillYellow---YcfK0 fill-yellow"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-apps-index-js-ec942641d334af59530c.js